import { simulateFrontendProtocolV1 } from './protocolV1Adapter';

// The only claim source for a submitted run.  UI state may lag or contain
// presentation-only counters; the finalized replay is the deterministic
// contract shared with backend authority.
export function buildFinalRunSnapshot(replay) {
  if (!replay || typeof replay !== 'object') throw new Error('replay_unavailable');
  const result = simulateFrontendProtocolV1(replay);
  return Object.freeze({
    replay,
    score: Number(result?.score || 0) || 0,
    acceptedMoves: Number(result?.moves || 0) || 0,
    maxCascade: Number(result?.maxCascade || 0) || 0,
  });
}

